import { useActionState, useEffect, useState } from "react";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
import IconButton from "../../../../components/icon-button";
import { PlusIcon } from "@heroicons/react/24/outline";
import { createCharityEventType, State } from "../actions";
import FormError from "../../../../components/form-error";
import toast from "react-hot-toast";

export default function CharityEventTypeCreateForm({
  onChanged,
}: {
  onChanged: () => void;
}) {
  const [formKey, setFormKey] = useState(0);
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };
  const [state, formAction, isPending] = useActionState(createCharityEventType, initialState);

  useEffect(() => {
    if (!state.success) return;

    toast.success("Charity event type created successfully");
    onChanged();
    setFormKey((key) => key + 1);
  }, [state, onChanged]);

  return (
    <form key={formKey} className="flex flex-col" action={formAction}>
      <div className="flex flex-1 gap-2 items-end">
        <div className="flex-1">
          <Label htmlFor="name">Name</Label>
          <Input id="name" name="name" type="text" placeholder="Enter name" required />
        </div>
        <IconButton label="Add" icon={PlusIcon} loading={isPending} />
      </div>
      <FormError id="name-error" message={state.errors?.name} />
    </form>
  );
}
